<template>
  <CContainer>
    <CCard class="mt-4 mb-1 p-3 col-sm-12">
      <CCardBody>
        <CForm class="p-2">
          <CCol sm="12" class="d-inline-block">
            <CInput
              label="Nombre Campaña: "
              addLabelClasses="text-muted font-weight-bold text-capitalize"
              :value.sync="campaign.name"
              :isValid="Boolean(campaign.name)"
              @blur="() => {}"
            />
          </CCol>
          <CCol sm="12" class="d-inline-block">
                        <CTextarea
                            label="Descipción: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="campaign.description"
                            @blur="() => {
                                
                            }"
                        />
                    </CCol>
                    <CCol sm="6" class="d-inline-block">
                        <CInput
                            type="date"
                            label="Fecha inicial: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="campaign.dateStart"
                            :isValid="Boolean(campaign.dateStart)"
                            @change="() => validateDates()"
                        />
                    </CCol>
                    <CCol sm="6" class="d-inline-block">
                        <CInput
                            type="date"
                            label="Fecha final: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="campaign.dateEnd"
                            :isValid="Boolean(campaign.dateEnd)"
                            @change="() => validateDates()"
                        />
                    </CCol>
                    <CCol sm="4" class="d-inline-block">
                        <CSelect
                            label="Estado: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="campaign.status"
                            :options="[
                                { value: 'A', label: 'Activa' },
                                { value: 'P', label: 'Pausada' },
                                { value: 'F', label: 'Finalizada' }                                
                            ]"
                            @change="() => {
                                
                            }"/>
                    </CCol>
                </CForm>
            </CCardBody>
            <CCardFooter class="d-flex justify-content-center">
                <CButton
                  color="success"
                  class="mr-2 d-inline-block"
                  :class="isValidForm ? '' : 'disabled'"
                  :disabled="!isValidForm"
                  @click="save()">
                  <CIcon name="cil-check-alt"/>
                  <span class="align-middle mr-2">Guardar</span>
                </CButton>
                <CButton
                  color="secondary"
                  class="mr-2 d-inline-block"
                  @click="() => $router.push({ path: rootPath })">
                  <CIcon name="cil-x"/>
                  <span class="align-middle mr-2">Cancelar</span>
                </CButton>
            </CCardFooter>
            <CElementCover  v-show="loading" class="w-100 y-100"/>
        </CCard>
    </CContainer>
</template>
<script>
  import moment from "moment";
  import { errorMessage } from "@/general";
  import {
    guardarCampania,
    actualizarCampania,
    obtenerCampania
  } from "@/api";

  export default {
    data() {
      return {
        rootPath: "",
        loading: false,
        isCreate: false,
        idCampaign: "",
        campaign: {
          name: '',
          description: '',
          dateStart: '',
          dateEnd: '',
          status: 'A'
        }
      }
    },
    methods: {
      moment,
      save() {
      this.isCreate ? this.createCampaign() : this.updateCampaign()
      },
      async createCampaign() {
          this.loading = true
          try {
            await guardarCampania(
              this,
              this.campaign.name,
              this.campaign.dateStart,
              this.campaign.dateEnd,
              this.campaign.status,
              this.campaign.description
            )
            this.$router.push(this.rootPath)
          } catch(error) {
            this.$store.commit('setAlert', {
              color: "danger",
              message: errorMessage(error),
              show: 5
            })
          } finally {
            this.loading = false
          }
      },
      async updateCampaign() {
        this.loading = true;

        try {
          await actualizarCampania(this,
            this.idCampaign,
            this.campaign.name,
            this.campaign.dateStart,
            this.campaign.dateEnd,
            this.campaign.status,
            this.campaign.description
          );

          this.$router.push({ path: this.rootPath });
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: errorMessage(error),
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      async getCampaign() {
          this.loading = true;
          
          try {
            const response = await obtenerCampania(this, this.idCampaign);
            
            this.campaign.name = response.nombre_Campania
            this.campaign.description = response.descripcion
            this.campaign.dateStart = response.fecha_Inicial
            this.campaign.dateEnd = response.fecha_Final
            this.campaign.status = response.estado
          } catch (error) {
            this.$store.commit("setAlert", {
              color: "danger",
              message: errorMessage(error),
              show: 5
            });
          } finally {
            this.loading = false;
          }
      },
      validateDates() {
        setTimeout(() => {
          if(!this.campaign.dateEnd.length) return;
          if(!moment(this.campaign.dateStart).isSameOrBefore(this.campaign.dateEnd)) {
            this.campaign.dateEnd = "";
            this.$store.commit("setAlert", {
              color: "warning",
              message: "Fecha final no es valida",
              show: 5
            });
          }
        }, 200);                                
      }
    },
    computed: {
      isValidForm() {
        return this.campaign.name && this.campaign.dateStart && this.campaign.dateEnd
      }
    },
    async mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.idCampaign = this.$router.currentRoute.params.id;
      this.isCreate = this.rootPath.includes("agregar");

      if (this.isCreate) {
        this.rootPath = this.rootPath.replace("/agregar", "");
      } else {
        this.rootPath = this.rootPath.replace(`/editar/${this.idCampaign}`, "");

        await this.getCampaign();
      }
    }
  }
</script>